import { Component, Injector, OnDestroy, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { INgxPrimengForm } from 'ngx-primeng-form';
import { DialogFormBaseComponent } from '../../../core/_base/dialog-form.base';
import { INgxCrudLayout } from '../../_models/_crud-layout';
import { INgxCrudActionCallback, INgxCrudLayoutDialogData } from '../../_models/_crud-manage';

@Component({
  selector: 'ngx-crud-manage-dialog',
  templateUrl: './ngx-crud-manage-dialog.component.html',
  styleUrls: ['./ngx-crud-manage-dialog.component.css']
})
export class NgxCrudManageDialogComponent extends DialogFormBaseComponent<INgxCrudLayoutDialogData<any>, any> implements OnInit, OnDestroy {

  // layout instance
  _layout: INgxCrudLayout;
  // data
  _data: any;

  constructor(injector: Injector) {
    super(injector);
  }

  ngOnInit(): void {
    // layout
    this._layout = this.dialogData.layout;
    // modal
    this._data = this.dialogData.model
    // patch value
    this._layout.form.action.onPatchValue = (formGroup: FormGroup, formItems: INgxPrimengForm[], data: any) => {
      // patch value
      this.patchValue(data, formGroup);
    };
  }

  handleOnAction(callback: INgxCrudActionCallback) {
    this.closeDialog(callback.action.serviceCall ? callback.result : null);
  }

  ngOnDestroy(): void {
    this.dispose();
  }

}
